import { render, staticRenderFns } from "./foreUP.vue?vue&type=template&id=da772270&scoped=true"
import script from "./foreUP.vue?vue&type=script&lang=js"
export * from "./foreUP.vue?vue&type=script&lang=js"
import style0 from "./foreUP.vue?vue&type=style&index=0&id=da772270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da772270",
  null
  
)

export default component.exports